import * as React from 'react';
import { connect } from 'react-redux';
import RequestConsultation from './components/RequestConsultation';
import ThankYou from './components/ThankYou';
import ImageBanner from '../../components/ImageBanner';
import FooterContent from '../../components/FooterContent';
import { GreyBackground, ResponsiveLayoutThin } from '../../components/ResponsiveLayout';
import { contact } from './content.json';
import { AuthRequestQuoteState, AuthRequestQuoteProps } from './AuthRequestQuote.types';
import analytics from '../../analytics';
import { getAccount } from '../../redux/thunks';
import { updateCustomerDetail } from '../../redux/actions/customer';

export type CustomerFragment = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
};

export class AuthRequestQuote extends React.Component<
  AuthRequestQuoteProps,
  AuthRequestQuoteState
> {
  constructor(props: AuthRequestQuoteProps) {
    super(props);

    this.state = {
      showThankYouPage: false
    };

    this.showThankYouPage = this.showThankYouPage.bind(this);
  }

  async componentDidMount(): Promise<void> {
    const { setVisibility } = this.props;
    analytics.pageLoadAuth('myaccount-solar-request-quote');
    try {
      await this.updateCustomerWithAccountInfo();
      this.updateCustomerWithPrimaryAddress();
      setVisibility(false);
    } catch (error) {
      setVisibility(false);
      this.setState({ showThankYouPage: false }, () => {
        throw error;
      });
    }
  }

  async updateCustomerWithAccountInfo(): Promise<void> {
    const { getAccount } = this.props;
    const account = await getAccount();
    const payload: CustomerFragment = this.mapAccountDetailsToPayload(account);

    this.handlePayload(payload);
  }

  updateCustomerWithPrimaryAddress(): void {
    const { primaryAddress, updateCustomerDetail } = this.props;
    updateCustomerDetail({ address: primaryAddress });
  }

  mapAccountDetailsToPayload(account): CustomerFragment {
    const customerFragment: CustomerFragment = {};
    if (account) {
      customerFragment.firstName = account.firstName;
      customerFragment.lastName = account.lastName;
      const communicationInfo = account.communicationInfo ? account.communicationInfo : undefined;
      if (communicationInfo) {
        const { email, mobile, phoneNumber } = communicationInfo;
        customerFragment.email = email;
        customerFragment.phone = mobile || phoneNumber;
      }
      return customerFragment;
    }
    return {};
  }

  handlePayload(payload: CustomerFragment): void {
    const { updateCustomerDetail } = this.props;

    if (payload.firstName && payload.lastName && payload.email) {
      updateCustomerDetail(payload);
    } else {
      throw new Error('Missing required account info');
    }
  }

  showThankYouPage(): void {
    this.setState({
      showThankYouPage: true
    });
  }

  render(): JSX.Element {
    const { showThankYouPage } = this.state;

    return (
      <GreyBackground>
        {!showThankYouPage && (
          <ImageBanner
            imageSrc={
              'https://res.cloudinary.com/originenergy/image/upload/v1536891404/5fa6954f4220b5c2a16ed301f2c22a1bbe425c6a.jpg'
            }
          />
        )}
        {showThankYouPage ? (
          <ThankYou data={contact} />
        ) : (
          <ResponsiveLayoutThin>
            <RequestConsultation showThankYouPage={this.showThankYouPage} />
          </ResponsiveLayoutThin>
        )}
        <FooterContent data={contact.content.footer} />
      </GreyBackground>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  { getAccount, updateCustomerDetail }
)(AuthRequestQuote);
